
/**
 * @fileOverview Expandable Content Controller Module
 * @modified 01/02/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ExpandableController',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        var ExpandableController = function ($element) {
			this.trigger = $element;
			this.target = $($element.attr('href'));
			this.init();
        };

		ExpandableController.prototype.init = function(){
			this.setupHandlers();
		};

		ExpandableController.prototype.setupHandlers = function(){
			var self = this;

			self.trigger.on('click', function(event){
				event.preventDefault();
				if($(this).hasClass('MMM--isActive')){
					self.collapseContent(event, $(this));
				}
				else {
					self.expandContent(event, $(this));
				}
			});
		};

		ExpandableController.prototype.expandContent = function(event, $element){
			$element.addClass('MMM--isActive').parent().addClass('MMM--isActive');
			$element.find('.MMM--icn_expand').removeClass('MMM--icn_expand').addClass('MMM--icn_collapse');
			this.target.addClass('MMM--isActive');
		};

		ExpandableController.prototype.collapseContent = function(event, $element){
			$element.removeClass('MMM--isActive').parent().removeClass('MMM--isActive');;
			$element.find('.MMM--icn_collapse').removeClass('MMM--icn_collapse').addClass('MMM--icn_expand');
			this.target.removeClass('MMM--isActive');
		};

        return ExpandableController;
    });

}(MMMRequire));
